// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3-8NO","label":"CategoryService_label__3Amj0","location":"CategoryService_location__2Kdcy"};